export enum HTTPResponseStatus {
  InternalError = 500,
  Timeout = 504,
  BadRequest = 400,
  NoContent = 204,
  Unauthorized = 401,
  Forbidden = 403,
  Conflict = 409,
  NotFound = 404,
  UnprocessableEntity = 422,
  ClientError = 451,
  Success = 200,
  Created = 201,
}
